import React from 'react';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';

const ExcelExport = ({ data, fileName }) => {
    const headers = [
        'S.No', 'Channel', 'Client', 'Project', 'Department', 
        'Employees'
    ];

    // Function to map data to headers
    const mapDataToHeaders = (data) => {
        return data.map((item, index) => {
            return {
                'S.No': index + 1,
                'Channel': item.channel || '',
                'Client': item.client || '',
                'Project': item.project || '',
                'Department': item.department || '',
                'Employees': item.employees || '',
            };
        });
    };

    const exportToExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(`${fileName}`);

        // To apply border style
        const applyBorder = (cell) => {
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        };

        // Define color and pattern for header
        const headerColor = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '8ea5e8' }
        };

        // Add header row with styling
        const headerRow = worksheet.addRow(headers);
        headerRow.font = { size: 10, bold: true };
        headerRow.alignment = { horizontal: 'center' };
        headerRow.height = 30;

        // Apply header color to columns
        for (let i = 1; i <= headers.length; i++) {
            const cell = worksheet.getCell(1, i);
            cell.fill = headerColor;
            applyBorder(cell);
        }

        if (data.length === 0) {
            worksheet.mergeCells('A2:F2');
            const cell = worksheet.getCell('A2');
            cell.value = 'No Data Found';
            cell.alignment = { horizontal: 'center' };
            applyBorder(cell);
        } 
        else {
            const mappedData = mapDataToHeaders(data);
            mappedData.forEach(row => {
                const excelRow = worksheet.addRow(headers.map(header => row[header]));
                excelRow.eachCell({ includeEmpty: true }, cell => {
                    applyBorder(cell);
                });
            });
        }

        // Set specific column 'G' width and wrap text
        const descriptionColumnIndex = 6;
        worksheet.getColumn(descriptionColumnIndex).width = 50;
        worksheet.getColumn(descriptionColumnIndex).eachCell({ includeEmpty: true }, cell => {
            cell.alignment = { wrapText: true };
        });

        // Auto adjust column widths
        worksheet.columns.forEach((column, index) => {
            if (index !== descriptionColumnIndex - 1) { // Skip column G
                let maxLength = 0;
                column.eachCell({ includeEmpty: true }, cell => {
                    if (cell.value && cell.value.toString().length > maxLength) {
                        maxLength = cell.value.toString().length;
                    }
                });
                column.width = maxLength + 2;
            }
        });

        // Save the workbook
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/octet-stream' });
        saveAs(blob, `${fileName}.xlsx`);
    };

    return (
        <button className="btn btn-secondary" onClick={exportToExcel}>
            <i className="fa fa-file-excel"></i> &nbsp; Export to Excel</button>
    );
}

export default ExcelExport;
